import React from 'react';
import { Car, Linkedin, Twitter, Facebook, Instagram } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-[#050508] border-t border-gray-800 pt-16 pb-8" data-id="element-7">
      <div className="container mx-auto px-4 md:px-6" data-id="element-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-9">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-10">
            <div className="flex items-center gap-2 mb-6 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-11">
              <div className="w-8 h-8 bg-cyan-900/30 rounded-lg flex items-center justify-center border border-cyan-500/30" data-id="element-12">
                <Car className="text-cyan-400 w-5 h-5" data-id="element-13" />
              </div>
              <span className="text-lg font-bold text-white" data-id="element-14">
                TIKA <span className="text-cyan-400" data-id="element-15">Mobility</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-16">
              Digitale Fahrzeugsteuerung für die nächste Mobilitätsgeneration.
              Sicher, intelligent und grenzenlos vernetzt.
            </p>
            <div className="flex gap-4" data-id="element-17">
              {[Linkedin, Twitter, Facebook, Instagram].map((Icon, i) => <a key={i} href="#" className="text-gray-500 hover:text-cyan-400 transition-colors" data-id="element-18">
                  <Icon className="w-5 h-5" data-id="element-19" />
                </a>)}
            </div>
          </div>

          {/* Links */}
          <div data-id="element-20">
            <h4 className="text-white font-semibold mb-6" data-id="element-21">Produkt</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-22">
              <li data-id="element-23">
                <button onClick={() => onNavigate('product')} className="hover:text-cyan-400 transition-colors" data-id="element-24">
                  Funktionen
                </button>
              </li>
              <li data-id="element-25">
                <button onClick={() => onNavigate('product')} className="hover:text-cyan-400 transition-colors" data-id="element-26">
                  Hardware
                </button>
              </li>
              <li data-id="element-27">
                <button onClick={() => onNavigate('product')} className="hover:text-cyan-400 transition-colors" data-id="element-28">
                  App
                </button>
              </li>
              <li data-id="element-29">
                <button onClick={() => onNavigate('product')} className="hover:text-cyan-400 transition-colors" data-id="element-30">
                  Sicherheit
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-31">
            <h4 className="text-white font-semibold mb-6" data-id="element-32">Lösungen</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-33">
              <li data-id="element-34">
                <button onClick={() => onNavigate('solutions')} className="hover:text-cyan-400 transition-colors" data-id="element-35">
                  OEM & Automotive
                </button>
              </li>
              <li data-id="element-36">
                <button onClick={() => onNavigate('solutions')} className="hover:text-cyan-400 transition-colors" data-id="element-37">
                  Car Sharing/Rental
                </button>
              </li>
              <li data-id="element-38">
                <button onClick={() => onNavigate('solutions')} className="hover:text-cyan-400 transition-colors" data-id="element-39">
                  Fleet Management
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-40">
            <h4 className="text-white font-semibold mb-6" data-id="element-41">Unternehmen</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-42">
              <li data-id="element-43">
                <button onClick={() => onNavigate('company')} className="hover:text-cyan-400 transition-colors" data-id="element-44">
                  Über uns
                </button>
              </li>
              <li data-id="element-45">
                <button onClick={() => onNavigate('contact')} className="hover:text-cyan-400 transition-colors" data-id="element-46">
                  Kontakt
                </button>
              </li>
              <li data-id="element-47">
                <button onClick={() => onNavigate('company')} className="hover:text-cyan-400 transition-colors" data-id="element-48">
                  Karriere
                </button>
              </li>
              <li data-id="element-49">
                <a href="https://pezula.ai/imprint/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors" data-id="element-50">
                  Impressum
                </a>
              </li>
              <li data-id="element-51">
                <a href="https://pezula.ai/data-privacy/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors" data-id="element-52">
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500" data-id="element-53">
          <p data-id="element-54">
            &copy; {new Date().getFullYear()} TIKA Mobility. Alle Rechte
            vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}